// import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
// import PaginatedList from '@theme/paginated-list';

// /**
//  * A custom element that renders a pagniated results list
//  */
// export default class ResultsList extends PaginatedList {
//   connectedCallback() {
//     super.connectedCallback();

//     mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
//     this.setAttribute('initialized', '');
//   }

//   disconnectedCallback() {
//     mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
//   }

//   /**
//    * Updates the layout.
//    *
//    * @param {Event} event
//    */
//   updateLayout({ target }) {
//     if (!(target instanceof HTMLInputElement)) return;

//     this.#animateLayoutChange(target.value);
//   }

//   /**
//    * Sets the layout.
//    *
//    * @param {string} value
//    */
//   #animateLayoutChange = async (value) => {
//     const { grid } = this.refs;

//     if (!grid) return;

//     await startViewTransition(() => this.#setLayout(value), ['product-grid']);

//     requestIdleCallback(() => {
//       const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
//       sessionStorage.setItem(`product-grid-view-${viewport}`, value);
//     });
//   };

//   /**
//    * Animates the layout change.
//    *
//    * @param {string} value
//    */
//   #setLayout(value) {
//     const { grid } = this.refs;
//     if (!grid) return;
//     grid.setAttribute('product-grid-view', value);
//   }

//   /**
//    * Handles the media query change event.
//    *
//    * @param {MediaQueryListEvent} event
//    */
//   #handleMediaQueryChange = (event) => {
//     const targetElement = event.matches
//       ? this.querySelector('[data-grid-layout="desktop-default-option"]')
//       : this.querySelector('[data-grid-layout="mobile-option"]');

//     if (!(targetElement instanceof HTMLInputElement)) return;

//     targetElement.checked = true;
//     this.#setLayout('default');
//   };
// }

// if (!customElements.get('results-list')) {
//   customElements.define('results-list', ResultsList);
// }
import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  /** @type {MutationObserver | undefined} */
  #searchVariantObserver;

  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.#deduplicateSearchVariants();

    const { grid } = this.refs;
    if (grid) {
      this.#searchVariantObserver = new MutationObserver(() => {
        this.#deduplicateSearchVariants();
      });
      this.#searchVariantObserver.observe(grid, { childList: true });
    }

    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
    this.#searchVariantObserver?.disconnect();
  }

  /**
   * Hide repeated matched variants while keeping the page marker elements in
   * the DOM. PaginatedList uses those elements to determine which page should
   * be fetched next, so removing them could make infinite scroll fetch the same
   * page repeatedly when an entire page consists of duplicates.
   *
   */
  #deduplicateSearchVariants() {
    const seenKeys = new Set();
    const elements = this.querySelectorAll('[data-search-variant-key]');

    for (const element of elements) {
      const key = element.getAttribute('data-search-variant-key');

      if (!key) continue;

      if (seenKeys.has(key)) {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      } else {
        seenKeys.add(key);
      }
    }
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
